export default __webpack_public_path__ + "static/media/xicon.a09ef2f1.png";